import * as ngCore from '@angular/core'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

import * as illustrations from '../../../illustrations'
import * as loader from '../../../loader'
import * as tableModels from '../../models'
import { AtnDsTableStore } from '../../store'
@ngCore.Component({
  imports: [illustrations.emptyState.Component, loader.Component],
  selector: 'table-empty-state',
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
// TODO: figure out better name for this component
export class Component<
  TTypeParams extends
    ec.models.TypeParams.Constraint = ec.models.TypeParams.Constraint,
> {
  /** @see {@link AtnDsTableStore} */
  public readonly store = ngCore.inject(AtnDsTableStore<TTypeParams>)

  /**
   * Computed property that determines the empty state title text based on
   * creation mode.
   */
  public readonly titleSg = ngCore.computed(
    (creation = this.store.creationSg()) =>
      creation
        ? 'Ready to get started? Click the button below'
        : 'Nothing to see here!',
  )

  /**
   * Computed property that determines the empty state description text based on
   * creation mode.
   */
  public readonly descriptionSg = ngCore.computed(
    (creation = this.store.creationSg()) =>
      creation
        ? "There is no content here yet, but it doesn't have to stay that way! You can click the button below to go ahead and get started"
        : 'No data was found. Not what you expected? Try refreshing, check your source data, or contact support.',
  )

  /**
   * Computed property that determines the empty state button text based on
   * creation mode.
   */
  public readonly actionSg = ngCore.computed(
    (creation = this.store.creationSg()) =>
      creation ? 'Get Started' : 'Refresh',
  )

  /**
   * Computed property that determines the empty state type based on creation
   * mode.
   */
  public readonly typeSg = ngCore.computed(
    (creation = this.store.creationSg()) => (creation ? 'add-row' : 'no-data'),
  )

  // TODO: error case should be implemented
  /**
   * Handling empty state button click, in case of
   * TODO: - creation mode is false, should be implemented
   * - creation mode is true, it will dispatch edit action
   * - otherwise it will call creation callback
   */
  public emptyStateClickHandler(source: 'error' | 'empty') {
    const creation = this.store.creationSg()

    if (creation && source === 'empty') {
      this.store.creationEntityHandling()
    } else {
      this.store
        .ecSg()
        ?.plugins.currentListPlugin.feature.actions.load.from(
          `EmptyState.Buttons.Refresh.Clicked`,
          tableModels.refreshTraceOptions,
        )
        .dispatch()
    }
  }
}
